import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-report-bts",
  templateUrl: "./report-bts.component.html",
  styleUrls: ["./report-bts.component.scss"],
})
export class ReportBtsComponent implements OnInit {
  @Input() obj;
  @Input() id;

  STAZIONI_BTS_MAPPING = {
    altezza_infra: "Altezza Infra Struttura",
    altezza_slm: "Altezza SLM",
    anno_piano_lavoro: "Anno Piano Lavoro",
    canone_acc_passivo: "Canone Accertato Passivo",
    canone_annuo_acc_attivo: "Canone Annuo Accertato Attivo",
    canone_attivo_msa: "Canone Attivo MSA",
    canone_attivo_msa_tim: "Canone Attivo MSA TIM",
    canone_attivo_msa_vod: "Canone Attivo MSA VODAFONE",
    canone_en_acc_attivo: "Canone Energia Accertato Attivo",
    canone_fatt_manuale: "Canone Fatturazione Manuale",
    canone_mas_acc_attivo: "Canone M&AS Accertato Attivo",
    canone_passivo_msa: "Canone Passivo MSA",
    canone_passivo_msa_tim: "Canone Passivo MSA TIM",
    canone_passivo_msa_vod: "Canone Passivo MSA VODAFONE",
    canoni_attivi: "Canoni Attivi",
    canoni_attivi_accertati: "Canoni Attivi Accertati",
    canoni_passivi: "Canoni Passivi",
    canoni_passivi_accertati: "Canoni Passivi Accertati",
    inwit_id: "Codice Sito",
    codice_sito_esterno: "Codice Sito Esterno",
    data_closing_acquisto_sito: "Data Closing Acquisto Sito",
    data_pubb_tr: "Data Pubblicazione TR",
    data_rogito: "Data Rogito",
    data_smantellamento: "Data Smantellamento",
    disdetta_presente: "Disdetta Presente",
    durata_dds: "Durata DDS",
    foglio: "Foglio",
    lat: "Latitudine",
    lon: "Longitudine",
    nome_sito: "Nome Sito",
    particella: "Particella",
    prop_infra: "Proprietà Infra Struttura",
    stato_tr: "Stato TR",
    sub: "Subalterno",
    tenants_presenti: "Tenants Presenti",
    tipo_infra: "Tipo Infra Struttura",
    origine_sito_decode: "Origine Sito",
    struttura_civile_decode: "Struttura Civile",
    territorio_decode: "Territorio",
    tipo_impianto_decode: "Tipo Impianto",
    terzi_infra_decode: "Terzi Infrastrutturali",
    stato_sito_decode: "Stato Sito",
    tipo_subloc_decode: "Tipo Sublocazione",
    data_disponibilita: "Data Disponibilità"
  };

  // Campi da formattare come DATA
  DATES = [
    'data_closing_acquisto_sito', 
    'data_pubb_tr', 
    'data_rogito', 
    'data_smantellamento', 
    'data_disponibilita'
  ];

  data;

  // inwit_id + nome_sito
  name;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.data = this.obj.data.reports[0].properties;
    this.name = this.data.name;

    delete this.data["report"];
    delete this.data["name"];

    delete this.data["origine_sito"];
    delete this.data["stato_sito"];
    delete this.data["struttura_civile"];
    delete this.data["territorio"];
    delete this.data["terzi_infra"];
    delete this.data["tipo_subloc"];
    delete this.data["tipo_impianto"];
  }
}
